/**
 @author xiaoye
 @date 2020/4/22 4:01 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//获取数据库表的字段类型
let token01 = null;
export const GetScreenList = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/GetScreenList?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};

let token02 = null;
export const RemoveScreen = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/RemoveScreen?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

let token03 = null;
export const RemoveScreenGroup = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[6] + "/RemoveScreenGroup?" + qs.stringify(data),
        method: "get",
        token: token03.token,
    })
};




